import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="loading-overlay">
      <div className="loading-content">
        <div className="spinner-ball"></div>
        <div className="loading-text">Carregando...</div>
      </div>
    </div>
  );
};

export default LoadingSpinner;